import * as CONNECTION from './Connection';

export const KILLSHEET_BY_NUMBER_REGEX = new RegExp(
  `${CONNECTION.SUPPLIER}${CONNECTION.API_VERSION_2}${CONNECTION.KILLSHEET}`
    .replace('/', '\\/') + `(\\d+)\\/?$`,
  'i' // case-insensitive
);
